import { useSelectReportData } from '../../hooks/useSelectReportData'
import '../../Report.css'
import { ExperimentItem } from '../ExperimentListItem/ExperimentItem'
import './Page8-experiments-science.css'

const Page8 = () => {
  const { experimentItems, isNoExperiments } = useSelectReportData()

  if (isNoExperiments) {
    return null
  }

  return (
    <>
      <hr />
      <div style={{ padding: '30px 12px 40px 12px' }}>
        <p
          className={'subtitle'}
          style={{ marginLeft: 12, marginRight: 12 }}
        >
          Scientific basis for experiments' results
        </p>
        {experimentItems.map((experimentItem, key) => {
          return (
            <div key={key}>
              <ExperimentItem {...experimentItem} />
              <div style={{ paddingLeft: 12, paddingRight: 12 }}>
                <p
                  className={'text-line'}
                  style={{ fontWeight: '700' }}
                >
                  Scientific basis
                </p>
                <p
                  className={'description-sub'}
                  dangerouslySetInnerHTML={{ __html: experimentItem.science_description }}
                ></p>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default Page8
